// dependencies
import React, { useCallback } from 'react'
import { useMediaQuery } from '@material-ui/core'
// helpers
import { slugify } from '@helpers/string-helper'

export const TEST_ID_CATEGORIES = {
  PRODUCT_TITLE: 'product-title',
  ADD_TO_CART_BUTTON: 'add-to-cart-button',
  FAVORITE_BUTTON: 'favorite-button',
  DELIVERY_TITLE: 'delivery-title',
  DELIVERY_PRODUCT: 'delivery-product',
  PAYMENT_TYPE: 'payment-type',
}

/**
 * Generates test-id for checkout elements
 * @return {(elementName: string) => string} Returns data-testid string
 */
export function useTest() {
  const isMobile = useMediaQuery('(max-width:1024px)')

  const generateTestId = useCallback(
    (elementCategory, elementName) =>
      `${isMobile ? `mobile-` : `desktop-`}${slugify(elementCategory)}-${slugify(elementName)}`,
    [isMobile],
  )
  return {
    generateTestId,
  }
}

// * HOC for class components
export const withTestId = Component => {
  const TestIdHOC = props => {
    const getTestID = useTest()

    return <Component getTestID={getTestID} {...props} />
  }

  return TestIdHOC
}
